export default __webpack_public_path__ + "static/media/taustakuva.924979fa.jpg";